<template lang="pug">
    .container(
        ref='container'
        )
        .animated-scroll(
            ref='animatedScroll',
            :class='theme'
            )
            .masked-text(v-if='content')
                .content(ref='content' :class='theme')
                    .section-block(
                        v-for='(block, blockIndex) in content',
                        :class='[block.position, block.modifier]',
                        :key='blockIndex'
                        )

                        .texts(v-if='block.type === "text"')

                            .texts__wrap(v-if='Array.isArray(block.textblocks)' v-html='block.textblocks.join("")')

                            .texts__side-illustration(v-if='block.hasillustration')
                                .quote(
                                    v-if='block.quote'
                                    )
                                    .quote__content(v-html='block.quote')
                                .image-block(
                                    v-if='block.imageblock'
                                    )
                                    ArticleImage(:name='block.imageblock.image' :title='block.imageblock.text' :alt='block.imageblock.text' animated=false)
                                .counter(
                                    v-if='block.counter'
                                    )
                                    AnimatedNumber(:value='block.counter.value' :text='block.counter.text' animated=false)

                .masked-text__mask-wrp
                    .masked-text__mask
                        .mask(ref='mask')
                            .bg-holder.top(:class='bgTheme')
                            .bg-holder.right(:class='bgTheme')
                            .bg-holder.bottom(:class='bgTheme')
                            .bg-holder.left(:class='bgTheme')
                            img(:src='require(`../../assets/img/text-appearing/${name}.svg`)')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

export default {
    components: {
        ArticleImage: () => import('../../components/ArticleImage.vue'),
        AnimatedNumber: () => import('../../components/AnimatedNumber.vue')
    },
    props: {
        content: {
            type: Array
        },
        settings: Object,
        name: String,
        theme: String,
        bgTheme: String,
        isActive: Boolean
    },
    data() {
        return {
            timeline: null,
            isInited: false,
            innerBlockPosition: 'top',
            isControlScroll: true
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.creatTimeline();
            if (document.documentElement.clientWidth < 768) {
                this.createScroll('top-middle', 'top-top');
            } else {
                this.createScroll();
            }
        },

        creatTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(this.$refs.mask, {opacity: 1, scale: 1}, {duration: 3, opacity: 0, scale: 6});
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 400vh;
    position: relative;
    overflow: hidden;

    @media (--viewport-tablet) {
        height: fit-content;
    }
}

.animated-scroll {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    min-height: 100vh;
    width: 100%;
    @media (--viewport-tablet) {
        position: static !important;
    }
    &.black {
        color: var(--color-white);
        background-color: var(--color-black);
    }
    &.white {
        color: var(--color-black);
        background-color: var(--color-white);
    }
    &.color {
        background-color: var(--theme);
    }
    // &.fixed {
    //     position: fixed;
    //     top: 0;
    //     left: 0;
    // }

    // &.bottom {
    //     bottom: 0;
    //     top: auto;
    // }
}

.masked-text {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    min-height: 100vh;
    @media (--viewport-laptop) {
        padding: 0px;
    }
    .section-block {
        &:last-child {
            padding-bottom: 20px;
        }
    }

    .content {
        width: 100%;
    }

    .masked-text__mask-wrp {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    &__mask {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: fit-content;
        height: fit-content;
        pointer-events: none;
        z-index: 1;
        /*width: 100vw;
        height: 100vh;
        overflow: hidden;*/
    }
}

.mask {
    padding: 100vh 100vw;
    width: 230vw;
    @media (--viewport-tablet) {
        width: 260vw;
    }
    //transform: scale(var(--transform));
    // transform: scale(calc(var(--transform) * 7 + 1));
    // opacity: calc(1 - var(--transform));
    // transition: transform, opacity 0.15s ease-out;
    img {
        width: calc(30vh + 30vw);
        height: auto;
        display: block;
        @media (--viewport-tablet) {
            width: calc(50vh + 50vw);
        }
    }
}
.bg-holder {
    position: absolute;
    &.color {
        background-color: var(--color-white);
    }
    &.black {
        background-color: var(--color-black);
    }
    &.color {
        background-color: var(--theme);
    }
    &.top {
        left: 0;
        top: 0;
        width: calc(100% + 2px);
        height: calc(100vh + 2px);
    }
    &.right {
        right: 0;
        top: 0;
        height: calc(100% + 2px);
        width: calc(100vw + 2px);
    }
    &.bottom {
        bottom: 0;
        width: calc(100% + 2px);
        left: 0;
        height: calc(100vh + 2px);
    }
    &.left {
        left: 0;
        top: 0;
        height: calc(100% + 2px);
        width: calc(100vw + 2px);
    }
}
</style>
